<template>
  <div class="wx-biz-teacher-message-push-input"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="tplInfo">
      <div class="header">
        <div class="label">消息内容</div>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <WxBizMessagePushForm ref="form"
                                :tpl-info="tplInfo"></WxBizMessagePushForm>
        </div>
      </div>
      <div class="footer">
        <div class="input">
          <el-select v-model="teachers"
                     size="mini"
                     value-key="id"
                     multiple
                     filterable
                     popper-class="wx-biz-teacher-message-push-input-dropdown"
                     placeholder="选择发送范围，一次最多发送10个人（填写账号或姓名搜索）"
                     remote
                     reserve-keyword
                     :remote-method="queryInfo"
                     :multiple-limit="10"
                     :loading="query.fetching"
                     :disabled="committing">
            <template v-if="query.info">
              <template v-if="query.info.items && query.info.items.length">
                <el-option v-for="item in query.info.items"
                           :key="item.id"
                           :label="`${item.loginId}/${item.trueName}`"
                           :value="item"
                           :disabled="!item.isBind">
                  <div class="custom-option">
                    <div class="label">
                      <span>{{item.loginId}}/{{item.trueName}}</span>
                    </div>
                    <div class="extra">
                      <template v-if="item.isBind">
                        <template v-if="item.isSub">
                          <el-tag size="mini"
                                  type="success">已订阅</el-tag>
                        </template>
                        <template v-else>
                          <el-tag size="mini"
                                  type="warning">未订阅</el-tag>
                        </template>
                      </template>
                      <template v-else>
                        <el-tag size="mini"
                                type="info">未绑定</el-tag>
                      </template>
                    </div>
                  </div>
                </el-option>
              </template>
              <el-pagination small
                             :page-size.sync="query.limit"
                             :current-page.sync="query.start"
                             :total="query.info.count || 0"
                             layout="prev, pager, next, ->, total"
                             @size-change="() => queryInfo(query.keyword)"
                             @current-change="() => queryInfo(query.keyword)">
              </el-pagination>
            </template>
          </el-select>
        </div>
        <div class="extra">
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleApply">{{committing ? '发送中...' : '开始发送'}}</el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>模板数据加载失败</div>
        <el-button type="text"
                   @click="loadTplInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import WxBizMessagePushForm from '../widget/form'
import Hint from '../../../../../../../../elements/Hint'
export default {
  name: 'WxBizTeacherMessagePushInput',
  components: {
    WxBizMessagePushForm,
    Hint
  },
  props: {
    biz: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      tplInfo: null,
      query: {
        fetching: false,
        keyword: '',
        start: 1,
        limit: 6,
        info: null
      },
      teachers: [],
      committing: false
    }
  },
  methods: {
    loadTplInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/message/wx/teacher/tplInfo',
        method: 'post',
        data: this.$qs.stringify({
          bizCode: this.biz.code
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.tplInfo = response.data['tplInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    queryInfo (query) {
      this.query.keyword = query
      if (query) {
        this.query.fetching = true
        this.$ajax({
          url: '/workspace/manager/message/wx/teacher/query',
          method: 'post',
          data: this.$qs.stringify({
            query: this.query.keyword,
            start: this.query.start,
            limit: this.query.limit
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.query.info = response.data['queryInfo'] || {}
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.query.fetching = false
        })
      } else {
        this.query.info = null
      }
    },
    handleApply () {
      const form = this.$refs.form
      if (form) {
        form.getInput().then(input => {
          const teachers = this.teachers || []
          if (!teachers.length) {
            this.$message.warning('请设置发送范围')
            return
          }
          this.handleSend(teachers, input)
        }).catch(err => {
          this.$message.warning(err.message)
        })
      }
    },
    handleSend (teachers, input) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/message/wx/teacher/bizSend',
        method: 'post',
        data: this.$qs.stringify({
          bizCode: this.biz.code,
          teacherIds: teachers.map(t => t.id),
          input: JSON.stringify(input)
        }, {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.teachers = []
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  mounted () {
    this.loadTplInfo()
  }
}
</script>

<style lang="scss">
  .wx-biz-teacher-message-push-input {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 0 15px;
      & > .label {
        color: #909399;
        font-size: 12px;
      }
    }
    & > .body {
      margin-top: 10px;
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    & > .footer {
      flex: none;
      padding: 15px;
      display: flex;
      align-items: stretch;
      & > .input {
        flex: auto;
        .el-select {
          width: 100%;
        }
      }
      & > .extra {
        margin-left: 10px;
        flex: none;
        .el-button {
          min-width: 90px;
          height: 100%;
        }
      }
    }
  }
  .el-select-dropdown {
    &.wx-biz-teacher-message-push-input-dropdown {
      .el-select-dropdown__wrap {
        .el-select-dropdown__list {
          .el-select-dropdown__item {
            .custom-option {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
          }
          .el-pagination {
            margin: 6px 0 -6px;
            padding: 6px 4px;
            border-top: 1px solid rgba(0,0,0,.03);
            .el-pagination__rightwrapper {
              .el-pagination__total {
                font-size: 12px;
              }
            }
            .btn-prev,
            .btn-next {
              padding: 0 6px;
              background-color: transparent;
            }
            .el-pager {
              & > li {
                font-weight: normal;
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }
</style>
